import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
const CardBody = (props)=>{
    const { bsStyle, className, ...rest } = props;
    return /*#__PURE__*/ _jsx("div", {
        ...rest,
        className: classnames('card-body', className, bsStyle ? `bg-${bsStyle} rcc-text-contrast-${bsStyle}` : '')
    });
};
const CardHeader = (props)=>{
    const { bsStyle, className, ...rest } = props;
    return /*#__PURE__*/ _jsx("div", {
        ...rest,
        className: classnames('card-header', className, bsStyle ? `bg-${bsStyle} rcc-text-contrast-${bsStyle}` : '')
    });
};
const CardFooter = (props)=>{
    const { bsStyle, className, ...rest } = props;
    return /*#__PURE__*/ _jsx("div", {
        ...rest,
        className: classnames('card-footer', className, bsStyle ? `bg-${bsStyle} rcc-text-contrast-${bsStyle}` : '')
    });
};
export const Card = (props)=>{
    const { bsStyle, ...rest } = props;
    return /*#__PURE__*/ _jsx("div", {
        ...rest,
        className: classnames('card', rest.className, bsStyle ? `bg-${bsStyle} rcc-text-contrast-${bsStyle}` : '')
    });
};
Card.Body = CardBody;
Card.Header = CardHeader;
Card.Footer = CardFooter;
